// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"3d28dcc1","346":"a2b935da","416":"3ff27755","428":"ce2d7512","476":"ef901290","536":"21f2f881"}[chunkId] + ".chunk.js";
};